import Dexie from 'dexie';

class DataBase {
    get crimeTable() {
        let db = new Dexie('ReactSampleDB');
        db.version(1).stores({ crimes: 'uuid' });
        return db.table("crimes");
    }
}

export default DataBase;